import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles(() => ({
  filterPaper: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    padding: "12px",
    borderRadius: 4,
    border: "1px solid #e5e2e5"
  },

  filterHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: "6px",
    marginBottom: "8px",
    borderBottom: "2px solid rgba(60, 60, 60, 0.2)"
  },

  filterTitle: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#4b1c46",
    textTransform: "uppercase",
    letterSpacing: "0.4px"
  },

  selectionCount: {
    fontSize: "12px",
    color: "#736973",
    whiteSpace: "nowrap"
  },

  selectionCountEmpty: {
    fontSize: "12px",
    fontWeight: 500,
    color: "#a32222",
    whiteSpace: "nowrap"
  },

  searchField: {
    marginBottom: "8px",
    "& .MuiOutlinedInput-input": {
      padding: "7px 10px",
      fontSize: "13px"
    }
  },

  filterList: {
    flex: 1,
    minHeight: 0,
    overflow: "auto"
  },

  listItem: {
    paddingLeft: "8px",
    paddingRight: "48px"
  },

  optionTextWrapper: {
    display: "flex",
    minWidth: 0,
    flex: 1
  },

  optionText: {
    margin: 0,
    "& span": {
      fontSize: "13px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    }
  },

  emptyText: {
    "& span": {
      fontSize: "13px",
      fontStyle: "italic",
      color: "#8f8a8f"
    }
  }
}));

export default useStyles;
